import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { submissionKeys } from '../queries/keys';
import { submissionPaths } from '../queries/paths';

// TSS vite/03 — server-state de las propuestas de donadora (staging con
// curaduría, public-donor-submissions.md / Q-122). La propuesta NO entra al SoT
// hasta que staff la promueve; el cliente ve el estado y edita/retira SOLO
// mientras `pending` (la UI deshabilita fuera de pending; el backend responde
// 409 defensivo si igual llega).
//
// Lecturas envueltas (envelope view "donor_submissions") → envelopeData() en el
// caller. Escrituras devuelven la propuesta plana (client-safe) → r.data.
// NUNCA se envía register/verification_state/animal_id/client_id/status (el
// backend los descarta; client_id sale del token).

export function useSubmissionsList({ limit, offset, verification_state } = {}) {
    return useQuery({
        queryKey: submissionKeys.list({ limit, offset, verification_state }),
        queryFn: ({ signal }) =>
            api.get(submissionPaths.list(), { params: { limit, offset, verification_state }, signal })
                .then((r) => r.data),
        placeholderData: keepPreviousData,
    });
}

export function useCreateSubmission() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(submissionPaths.create(), payload).then((r) => r.data),
        onSuccess: () => qc.invalidateQueries({ queryKey: submissionKeys.all }),
    });
}

export function useUpdateSubmission(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(submissionPaths.update(id), payload).then((r) => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: submissionKeys.detail(id) });
            qc.invalidateQueries({ queryKey: submissionKeys.all });
        },
    });
}

// Retirar = soft-delete de una propuesta `pending` (DELETE, contract).
export function useWithdrawSubmission() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(submissionPaths.remove(id)).then((r) => r.data),
        onSuccess: () => qc.invalidateQueries({ queryKey: submissionKeys.all }),
    });
}
